/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsliveroomnote3Inputs */

const en_ticketsliveroomnote3 = /** @type {(inputs: Ticketsliveroomnote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests scanned at the door also join the Live Room. They stay hidden there until they show themselves.`)
};

const de_ticketsliveroomnote3 = /** @type {(inputs: Ticketsliveroomnote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste, die am Einlass gescannt werden, kommen auch in den Live Room. Dort sind sie unsichtbar, bis sie sich selbst zeigen.`)
};

/**
* | output |
* | --- |
* | "Guests scanned at the door also join the Live Room. They stay hidden there until they show themselves." |
*
* @param {Ticketsliveroomnote3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsliveroomnote3 = /** @type {((inputs?: Ticketsliveroomnote3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsliveroomnote3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsliveroomnote3(inputs)
	return de_ticketsliveroomnote3(inputs)
});
export { ticketsliveroomnote3 as "ticketsLiveRoomNote" }